<template>
  <BootstrapModal class="CustomizeLayout" v-on="$listeners">
    <div>
      <p>Selecteer de kolommen die zichbaar moeten zijn in de tabel</p>
      <div v-if="layoutFilter">
        <FormInput v-model="search" placeholder="Filter..." />
      </div>
      <div>
        <button
          v-for="val in filteredColumns"
          class="item"
          :class="{ active: activeColumns.includes(val) }"
          :key="val"
          @click="activateColumn(val)"
        >
          {{ val }}

          <svg
            v-if="activeColumns.includes(val)"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
      </div>

      <template v-if="extraSections && extraSections.length">
        <div v-for="section in extraSections" :key="section">
          <h5 class="section-title">{{ section.title }}</h5>

          <button
            v-for="val in section.values"
            :key="val"
            :class="{
              active: extraSelectedValues.some(
                (selected) =>
                  selected.title === section.title && selected.value === val
              ),
            }"
            class="item"
            @click="toggleValue(section.title, val)"
          >
            {{ val }}
          </button>
        </div>
      </template>
    </div>

    <template #title>
      <span v-if="title" v-html="title"></span>
      <span v-else>Kolommen aanpassen</span>
    </template>

    <template #slot-options>
      <div>
        <button
          type="button"
          class="btn btn-secondary"
          id="submit-button"
          @click="resetLayout"
        >
          Reset naar standaardconfiguratie
        </button>

        <button
          type="button"
          class="btn btn-primary"
          id="submit-button"
          style="margin-left: 7px"
          @click="saveColumnLayout"
        >
          Opslaan
        </button>
      </div>
    </template>
  </BootstrapModal>
</template>

<script>
import BootstrapModal from "../BootstrapModal.vue";
import FormInput from "/src/components/Inputs/FormInput.vue";

export default {
  name: "CustomizeLayoutModal",
  components: {
    BootstrapModal,
    FormInput,
  },
  props: {
    title: String,

    extraSections: Array,
    selectedExtraSections: Array,
    selectCustomization: Function,
    layoutFilter: Boolean,
    columns: {
      type: Array,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    defaultColumns: {
      type: Array,
      default: () => [],
      required: false,
    },
    currentColumns: {
      type: Array,
      default: () => [],
      required: false,
    },
    callback: {
      type: Function,
      required: true,
    },
  },
  created() {
    const savedValues = JSON.parse(localStorage.getItem(this.id));
    if (savedValues && savedValues.length) {
      this.activeColumns = savedValues;
    }
  },
  data() {
    return {
      search: "",
      activeColumns: this.currentColumns.slice(),
      extraSelectedValues: this.selectedExtraSections
        ? this.selectedExtraSections.slice()
        : [],
    };
  },
  methods: {
    toggleValue(title, value) {
      const index = this.extraSelectedValues.findIndex(
        (selected) => selected.title === title && selected.value === value
      );
      if (index > -1) {
        this.extraSelectedValues.splice(index, 1);
      } else {
        this.extraSelectedValues.push({ title, value });
      }
    },

    resetLayout() {
      this.saveLayout(this.defaultColumns);
      this.$emit("close");
    },
    saveLayout(columns) {
      if (this.selectCustomization)
        this.selectCustomization(this.extraSelectedValues);

      localStorage.setItem(this.id, JSON.stringify(columns));
      this.callback(columns.slice());
    },
    activateColumn(val) {
      if (!this.activeColumns.includes(val)) {
        this.activeColumns.push(val);
      } else {
        this.activeColumns.splice(this.activeColumns.indexOf(val), 1);
      }
    },
    saveColumnLayout() {
      this.saveLayout(this.activeColumns);
      this.$emit("close");
    },
  },
  computed: {
    filteredColumns() {
      const search = this.search;
      if (!search) return this.columns;
      return this.columns.filter((column) => column.includes(search));
    },
  },
};
</script>

<style scoped>
.CustomizeLayout {
  flex-basis: 900px;
}

.section-title {
  font-size: 1.1825em;
}

.section-title {
  margin-top: 24px;
}

svg {
  transform: translateY(-1px);
  color: #065f46;
}

.item {
  display: inline-block;
  background-color: #f3f3f3;
  border-radius: 1px;
  padding: 4px 13px;
  margin-top: 6px;
  margin-left: 6px;
  cursor: pointer;
  transition-duration: 0.2s;
}

p {
  margin-bottom: 4px;
  font-size: 12px !important;
}

.item:hover {
  filter: brightness(1.015);
}

.item.active:hover {
  filter: brightness(1.085);
}

.item.active {
  background-color: #d1fae5;
  color: #065f46;
  font-weight: 700;
}

h5 {
  font-size: 1.0625em;
}
</style>
